import Module from '../../utils/modules/Module';
import Splide from "@splidejs/splide";
import EventsManager from "../../utils/events/EventsManager";
import CustomEvents from "../../utils/events/CustomEvents";

export default class SliderModule extends Module {
  constructor(options) {
    super(options)

    this.onSlideUpdate = this.onSlideUpdate.bind(this);

    this.paginationLimit = 8;
    this.paginationLimitSlide = 2;

    this.init();
  }


  /**
   * Initial state to start all slider
   */
  init() {
    // Variables
    let self = this;
    let tximgs = document.querySelectorAll('.splide-tximg');
    let medias = document.querySelectorAll('.splide-media');
    let heros = document.querySelectorAll('.splide-hero');
    let teasers = document.querySelectorAll('.splide-teaser');
    let galleries = document.querySelectorAll('.splide-gallery');
    let plays = document.querySelectorAll('.splide-play');
    // let ctas = document.querySelectorAll('.splide-cta');

    // Adjust splide's arrows (svg)
    setTimeout(function () {
      document.querySelectorAll('.splide__arrow').forEach(function (el, i) {
        el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="71" height="15.668" viewBox="0 0 71 15.668"  fill="currentColor"><path' +
          ' d="M70 8.401H0v-1h70z"/><path d="M63.338 15.668l-.707-.709 6.971-6.939L62.623.69l.723-.689L71 8.04l-.346.345z"/></svg>';
      });
    }, 100);

    // Check for the right slider to construct
    if (tximgs.length !== 0) {
      this.createTximg();
    }
    if (medias.length !== 0) {
      this.createMedia();
    }
    if (heros.length !== 0) {
      this.createHero();
    }
    if (teasers.length !== 0) {
      this.createTeaser();
    }
    if (galleries.length !== 0) {
      this.createGallery();
    }
    if (plays.length !== 0) {
      this.createPlayTrue();
    }
  }


  /** ------------------------------
   * Slider for text & images
   --------------------------------- */
  createTximg() {
    let self = this;
    document.querySelectorAll('.splide-tximg').forEach(function (el, i) {
      el.classList.add('splide-tximg--' + i);
      let autoplay = el.classList.contains('slider-autoplay');

      const splide = new Splide('.splide-tximg--' + i, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: '4vw',
        keyboard: true,
        slideFocus: false,
        autoHeight: true,
        lazyLoad: "nearby",
        speed: 650,
        easing: 'cubic-bezier(.60, 0, .18, 1)',
        autoplay: autoplay,
        pauseOnHover : !autoplay,
        pauseOnFocus : !autoplay,
      }).mount();

      // accessibility
      let allSlides = document.querySelectorAll('.splide-tximg--' + i + ' .splide__slide');
      self.accessibilityLinks(allSlides);


      if (autoplay) {
        let toggleButton = el.parentElement.querySelector('.splide__toggle');
        self.autoplayToggle(toggleButton,splide);
      }

      splide.on("moved", function () {
        self.accessibilityLinks(allSlides);
      });

      EventsManager.on(CustomEvents.summary.SUMMARY_OPEN, function () {
        setTimeout(function () {
          splide.refresh()
        }, 650);
      }); // refresh on summary toogle
    }); // end each
  } // end createQuotes


  /** ------------------------------
   * Slider for images
   --------------------------------- */
  createMedia() {
    document.querySelectorAll('.splide-media').forEach(function (el, i) {
      el.classList.add('splide-media--' + i);

      const splide = new Splide('.splide-media--' + i, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: '4vw',
        keyboard: true,
        slideFocus: false,
        autoHeight: true,
        lazyLoad: "nearby",
        speed: 650,
        easing: 'cubic-bezier(.60, 0, .18, 1)',
      }).mount();

      //refresh on summary toogle
      EventsManager.on(CustomEvents.summary.SUMMARY_OPEN, function () {
        setTimeout(function () {
          splide.refresh()
        }, 650);
      });
    });
  }

  /** ------------------------------
   * Slider for images in play-true
   --------------------------------- */
  createPlayTrue() {
    document.querySelectorAll('.splide-play').forEach(function (el, i) {
      el.classList.add('splide-play--' + i);

      const splide = new Splide('.splide-play--' + i, {
        type: "loop",
        // perPage: 1,
        // perMove: 1,
        gap: '30px',
        keyboard: true,
        slideFocus: false,
        autoWidth: true,
        speed: 650,
        easing: 'cubic-bezier(.60, 0, .18, 1)',
      }).mount();
    });
  }


  /** ------------------------------
   * Slider for hero - mobile only
   --------------------------------- */
  createHero() {
    document.querySelectorAll('.splide-hero').forEach(function (el, i) {
      el.classList.add('splide-hero--' + i);

      new Splide('.splide-hero--' + i, {
        type: "fade",
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: false,
        gap: '4vw',
        keyboard: false,
        slideFocus: false,
        lazyLoad: "nearby",
        speed: 180,
        rewind: true,
        easing: 'cubic-bezier(.60, 0, .18, 1)',
        autoplay: true,
        interval: 2000,
        destroy: true,
        breakpoints: {
          770: {
            destroy: false,
          },
        }
      }).mount();

    });
  }

  /** ------------------------------
   * Slider for Gallery
   --------------------------------- */
  createGallery() {
    let self = this;

    document.querySelectorAll('.splide-gallery').forEach(function (el, i) {
      el.classList.add('splide-gallery--' + i);

      const splide = new Splide('.splide-gallery--' + i, {
        type: "loop",
        perPage: 1,
        perMove: 1,
        gap: '4vw',
        keyboard: true,
        slideFocus: false,
        pagination: false,
        fixedHeight: '100vh',
        lazyLoad: "nearby",
        speed: 500,
        easing: 'cubic-bezier(.60, 0, .18, 1)',
      }).mount();

      const allGalleryVideos = el.querySelectorAll('[data-video]');

      //refresh on summary toogle
      EventsManager.on(CustomEvents.modal.MODAL_OPEN, function () {
        setTimeout(function () {
          splide.refresh()
        }, 100);
        setTimeout(function () {
          let index = document.querySelector('.gallery-btn.active').dataset.index;

          splide.go(parseInt(index) - 1);

          if (allGalleryVideos.length > 0) {
            self.handleSliderVideos(allGalleryVideos);
          }
        }, 100);
      });

      //refresh on summary toogle
      EventsManager.on(CustomEvents.modal.MODAL_CLOSE, function () {
        if (allGalleryVideos.length > 0) {
          self.stopSliderVideos(allGalleryVideos);
        }
      });

      splide.on('moved', () => {
        if (allGalleryVideos.length > 0) {
          self.handleSliderVideos(allGalleryVideos);
        }
      });
    });
  }

  /** ------------------------------
   * Slider for teasers
   --------------------------------- */
  createTeaser() {
    document.querySelectorAll('.splide-teaser').forEach((el, i) => {
      el.classList.add('splide-teaser--' + i);
      let autoplay = el.classList.contains('slider-autoplay');
      let self = this,
        per = 1,
        pages = true,
        mobile = false,
        desktop = true,
        nbr = 1,
        gap = '20px',
        image = false,
        imageSmall = false;
      if (el.dataset.pages) {
        pages = false;
      }
      if (el.dataset.desktop) {
        desktop = false;
      }
      if (el.dataset.nb) {
        nbr = el.dataset.nb;
      }
      if (el.dataset.gap) {
        gap = el.dataset.gap;
      }
      if (el.dataset.image) {
        image = el.dataset.image;
      }
      if (el.dataset.imageSmall) {
        imageSmall = el.dataset.imageSmall;
      }

      if (image == 'true') {
        if (nbr <= 2) {
          desktop = true;
        } else {
          per = 2;
        }
      } else if (imageSmall == 'true') {
        if (nbr <= 3) {
          desktop = true;

          if (nbr == 1) {
            mobile = true;
          }
        } else {
          per = 3;
        }
      } else {
        if (nbr <= 4) {
          desktop = true;
        } else {
          per = 4;
        }
      }

      const splide = new Splide('.splide-teaser--' + i, {
        type: "loop",
        perPage: per,
        perMove: per,
        gap: gap,
        slideFocus: false,
        keyboard: 'focused',
        lazyLoad: 'nearby',
        pagination: pages,
        arrows: true,
        speed: 650,
        easing: 'cubic-bezier(.60, 0, .18, 1)',
        destroy: desktop,
        padding: {right: 0},
        autoplay: autoplay,
        pauseOnHover : !autoplay,
        pauseOnFocus : !autoplay,
        breakpoints: {
          770: {
            perPage: 1,
            perMove: 1,
            destroy: mobile,
            padding: {right: '30vw'},
          },
        }
      }).mount()

      // place specials dots on mobile if there's too much slides
      if (splide.length > this.paginationLimit) {
        this.onSlideUpdate({splide});

        splide.on('move', (newIndex, prevIndex, destIndex) => {
          this.onSlideUpdate({
            splide,
            newIndex,
            prevIndex,
            destIndex
          });
        });
      }

      // refresh on summary toogle
      EventsManager.on(CustomEvents.summary.SUMMARY_OPEN, function () {
        setTimeout(function () {
          splide.refresh()
        }, 650);
      });

      // accessibility
      let allSlides = document.querySelectorAll('.splide-teaser--' + i + ' .splide__slide');
      this.accessibilityLinks(allSlides, desktop, el);
      if (autoplay) {
        let toggleButton = el.parentElement.querySelector('.splide__toggle');
        self.autoplayToggle(toggleButton,splide,desktop);
      }

      splide.on("moved", function () {
        self.accessibilityLinks(allSlides, desktop, el);
      });

      window.addEventListener("resize", function (event) {
        self.accessibilityLinks(allSlides, desktop, el);
        if (autoplay) {
          let toggleButton = el.parentElement.querySelector('.splide__toggle');
          self.autoplayToggle(toggleButton,splide,desktop);
        }
      })
    });
  }

  onSlideUpdate(options) {
    const index = options.splide.index;
    const bullets = options.splide.Components.Pagination.data.items;
    const bulletsWrapper = options.splide.Components.Pagination.data.list;

    //Check to prevent loop animation glitches
    const isSlidingPrevLoop = options.newIndex === bullets.length - 1 && options.prevIndex === 0;
    const isSlidingNextLoop = options.newIndex === 0 && options.prevIndex === bullets.length - 1;

    // IF WINDOW SUPERIOR TO 700px WE RESET EVERYTING AND DO NOTHING
    if (window.innerWidth > 700) {
      bullets.forEach(bullet => {
        bullet.li.style.transform = `scale(1)`
      })

      bulletsWrapper.classList.remove('animated')
      return;
    }

    if (isSlidingPrevLoop || isSlidingNextLoop) {
      bulletsWrapper.classList.remove('animated')
    } else {
      bulletsWrapper.classList.add('animated')
    }

    //moving the track of pagination
    const moveDistList = Math.round(((bullets.length * 0.5) - index) * 20) - 10
    bulletsWrapper.style.transform = `translateX(${moveDistList}px)`;

    //Scaling the bullets
    bullets.forEach((bullet, bIndex) => {
      const diff = Math.abs(index - bIndex);
      if (diff > this.paginationLimitSlide - 2) {
        const scale = Math.max(0, 1 - ((diff - (this.paginationLimitSlide - 2)) * 0.25))
        bullet.li.style.transform = `scale(${scale})`
      } else {
        bullet.li.style.transform = `scale(1)`
      }
    })
  }

  accessibilityLinks(slides, destroyed, slider) {
    slides.forEach(item => {
      if (item.classList.contains('is-active')) {
        item.setAttribute('aria-hidden', 'false');
        if (item.querySelector('a')) {
          item.querySelector('a').setAttribute('tabindex', '0');
        }
      } else {
        item.setAttribute('aria-hidden', 'true');
        if (item.querySelector('a')) {
          item.querySelector('a').setAttribute('tabindex', '-1');
        }
      }
    });

    if (window.innerWidth > 770 && destroyed) {
      slides.forEach(item => {
        item.setAttribute('aria-hidden', 'false');
        if (item.querySelector('a')) {
          item.querySelector('a').setAttribute('tabindex', '0');
        }
      });
      if (slider.hasAttribute('tabindex')) {
        slider.closest('.splide').removeAttribute('tabindex');
      }
      setTimeout(function () {
        if (slider.querySelector('.splide__track')) {
          slider.querySelector('.splide__track').style.overflow = 'visible';
        }
      }, 100);
    } else {
      setTimeout(function () {
        if (slider && slider.querySelector('.splide__track')) {
          slider.querySelector('.splide__track').style.overflow = 'hidden';
        }
      }, 100);
    }
  }

  autoplayToggle(toggleButton, splide, desktop = false) {

    if(window.innerWidth > 770 && desktop){
      toggleButton.style.display = 'none';
    }
    else{
      toggleButton.style.display = 'block';
    }
    var pausedClass = 'is-paused';
    // Remove the paused class and change the label to "Pause".
    splide.on( 'autoplay:play', function () {
      toggleButton.classList.remove( pausedClass );
      toggleButton.innerHTML = '<svg\n' +
        '          class="splide__toggle__pause"\n' +
        '          viewBox="0 0 24 24"\n' +
        '          xmlns="http://www.w3.org/2000/svg"\n' +
        '        >\n' +
        '          <path d="m2 1v22h7v-22zm13 0v22h7v-22z"/>\n' +
        '        </svg>';
    } );

    // Add the paused class and change the label to "Play".
    splide.on( 'autoplay:pause', function () {
      toggleButton.classList.add( pausedClass );
      toggleButton.innerHTML = '<svg\n' +
        '          class="splide__toggle__play"\n' +
        '          viewBox="0 0 24 24"\n' +
        '          xmlns="http://www.w3.org/2000/svg"\n' +
        '        >\n' +
        '          <path d="m22 12-20 11v-22l10 5.5z"/>\n' +
        '        </svg>'
    } );

    toggleButton.addEventListener('click', function () {
      var flag     = 99;
      var Autoplay = splide.Components.Autoplay;

      if ( toggleButton.classList.contains( pausedClass ) ) {
        Autoplay.play( flag );
      } else {
        Autoplay.pause( flag );
      }
    });
  }

  handleSliderVideos(allVideos) {
    this.stopSliderVideos(allVideos);

    setTimeout(function () {
      allVideos.forEach(function (video) {
        const parentSlide = video.closest('.splide__slide');
        const videoPoster = video.querySelector('.media-video-poster');

        if (parentSlide.classList.contains('is-active')) {
          const videoTrigger = parentSlide.querySelector('.btn-play');
          videoPoster.classList.add('is-hidden');

          setTimeout(function () {
            videoTrigger.click();
          }, 200);
        }
      });
    }, 600);
  }

  stopSliderVideos(allVideos) {
    allVideos.forEach(function (video) {
      const videoPoster = video.querySelector('.media-video-poster');
      const videoClose = video.querySelector('.btn-close');

      if (videoPoster.classList.contains('is-hidden')) {
        videoClose.click();
        videoPoster.classList.remove('is-hidden');
      }
    });
  }
}
